export const FunnelConstants = {
  serviceIntervals: {
    Recurring: 'Recurring',
    DeepClean: 'Deep Clean',
    MoveIn: 'Move In',
    MoveOut: 'Move Out'
  },
  removedItems: 'removedItems'
};
